// extracted by mini-css-extract-plugin
export default {"container":"OuterServicesRefinements_container__Ut1aJ","aside":"OuterServicesRefinements_aside__BPNsT","title":"OuterServicesRefinements_title__47w5K"};